import React from "react";
import { CustomHeader } from 'react-calendar-timeline/lib' // new
import moment from 'moment-timezone';

// {interval.startTime.format("ddd, MMM Do")}

/**
 * Returns the date header that will be visible in the one to two day schedule. It changes based on the size of the screen.
 * @param {*} param0
 */
const CustomDateHeader = ({ unit, textAlign, widescreen }) => {
  moment.tz.setDefault('UTC');
  const spacer = <span style={{ color: 'darkgray' }}> ------ </span>;

  return (
  <CustomHeader unit={unit}>
    {({
      headerContext: { intervals },
      getRootProps,
      getIntervalProps,
      showPeriod
    }) => {
      return (
        // Custom Header w/ date wallpapered i.e. 'Mon, Jul 15th - Mon, Jul 15h - Mon, Jul 15th ...'
        <div {...getRootProps({ style: { fontSize: 12 } })}>
          {intervals.map(interval => {
            const intervalStyle = {
              // height:
              lineHeight: '30px',
              textAlign: textAlign,
              border: '0.5px solid gray',
              // cursor: 'pointer',
              backgroundColor: 'darkgray',
              color: 'white',
            }
            return (
              <div
                // onClick={() => {
                //   showPeriod(interval.startTime, interval.endTime)
                // }}
                {...getIntervalProps({
                  interval,
                  style: intervalStyle,
                })}
              >
                <div className="sticky" style={{leftMargin: '15px', rightMargin: '15px' }}>
                  {interval.startTime.format("ddd, MMM Do")}
                  {spacer} {interval.startTime.format("ddd, MMM Do")}
                  {spacer} {interval.startTime.format("ddd, MMM Do")}
                  {spacer} {interval.startTime.format("ddd, MMM Do")}
                  {spacer} {interval.startTime.format("ddd, MMM Do")}
                  {spacer} {interval.startTime.format("ddd, MMM Do")}
                  {spacer} {interval.startTime.format("ddd, MMM Do")}
                  {spacer} {interval.startTime.format("ddd, MMM Do")}
                  {spacer} {interval.startTime.format("ddd, MMM Do")}
                  {spacer} {interval.startTime.format("ddd, MMM Do")}
                </div>
              </div>
            )
          })}
        </div>
      )
    }}
</CustomHeader>

  );
}

export default CustomDateHeader;



// WEBPACK FOOTER //
// ./src/Components/Schedule/OneTwoDay/CustomDateHeader.js